import _extends from "@babel/runtime/helpers/extends";
import React, { memo, useCallback } from 'react';
import { AnalyticsPusherTabs } from "../utils/analytics";
export var withAnalyticsTabs = function withAnalyticsTabs(WrappedComponent) {
  return /*#__PURE__*/memo(function (props) {
    var headerBarConfig = props.headerBarConfig,
      onTabChange = props.onTabChange;
    var handleTabChange = useCallback(function (tabName) {
      AnalyticsPusherTabs.pushClickEvent({
        block_other_tab_click: tabName,
        block_title: headerBarConfig === null || headerBarConfig === void 0 ? void 0 : headerBarConfig.headerText,
        block_subtitle: headerBarConfig === null || headerBarConfig === void 0 ? void 0 : headerBarConfig.subtitleText
      });
      onTabChange === null || onTabChange === void 0 ? void 0 : onTabChange(tabName);
    }, [headerBarConfig, onTabChange]);
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      onTabChange: handleTabChange,
      "data-t-id": "src-hocs"
    }));
  });
};